import axios from 'axios';

import cfac22 from '../cfac22';

export async function getEstablishment(uId, payload) {
  if (!payload.userQuery) delete payload.userQuery;

  return new Promise((resolve, reject) => {
    Promise.resolve()
      .then(() => {
        const config = {
          method: 'post',
          url: cfac22('API_HOST_V2') + '/getStorePlace/establishments',
          headers: {
            'Full-Url': window.location.href,
          },
          data: { ...payload, partnerId: cfac22('partnerId') },
          withCredentials: true,
        };

        axios(config)
          .then(function (response) {
            resolve(response.data.result);
          })
          .catch(function (error) {
            reject(error.response.data.error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// exemplo de payload
// {
//   "systemQuery": {
//     "grupo1": [
//       {
//         "type": "like",
//         "field": "descricao",
//         "value": "cashback"
//       }
//     ]
//   },
//   "orderType": "location",
//   "hasPromo": false,
//   "geoFocus": {
//     "lat": "-23.5983184",
//     "long": "-46.641581"
//   },
//   "geoRadius": 10000,
//   "plataform": "web",
//   "from": 0,
//   "size": 1
// }

